import auth from "./auth"
import axios from "axios";

export default {
    state: {
        FB: false,
        isConnected: false,
    },
    mutations: {
        logout(state) {
            state.status = ''
            state.token = ''
            state.user = {}
            let visitor = ''
            if (localStorage.getItem('visitor')) {
                visitor = localStorage.getItem('visitor')
            }
            let cookieShow = localStorage.getItem('cookieShow')
            localStorage.clear()
            localStorage.setItem('cookieShow', cookieShow)
        },
    },
    actions: {

    },
    getters: {

    },
}
